import { useLocation, useNavigationType } from 'react-router-dom';
import { useLayoutEffect } from 'react';

const ScrollToTop = () => {
    const { pathname } = useLocation();
    const navigationType = useNavigationType();

    useLayoutEffect(() => {
        if (navigationType === 'POP') return;
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, [navigationType, pathname]);

    return null;
}

export default ScrollToTop;
